import { i18n } from 'i18n';

export const CURRENCIES = {
	EUR: i18n.t('Euro'),
	USD: i18n.t('United States Dollars'),
	RUB: i18n.t('Russian Rubles'),
};
